// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const ComissionMasterUniList = lazy(() => import('../../views/comissionMasterUni/list'))
const ComissionMasterUni = [
  {
    path: 'comissionMasterUni/list',
    element: <ComissionMasterUniList/>
  }
]


export default ComissionMasterUni